import React, { useContext } from "react";
import { themeContext } from "../../Context";
import "./Brands.css";
const Brands = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="brands" id="brands">
      <div className="achievement">
        {/* darkMode */}
        <div className="circle" style={{ color: darkMode ? "var(--pink)" : "" }}>
          A+
        </div>
        <span style={{ color: darkMode ? "white" : "" }}>Merk </span>
        <span>Oculus</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{ color: darkMode ? "var(--pink)" : "" }}>
          A+
        </div>
        <span style={{ color: darkMode ? "white" : "" }}>Merk </span>
        <span>Vive</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{ color: darkMode ? "var(--pink)" : "" }}>
          A
        </div>
        <span style={{ color: darkMode ? "white" : "" }}>Merk </span>
        <span>Google</span>
      </div>
    </div>
  );
};

export default Brands;
